import React, { useEffect } from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'
import ExtraFooterShell from 'components/flex/ExtraFooter/ExtraFooterShell'

import LayoutPage from 'components/layout/LayoutPage'
// import { HelmetProvider } from 'react-helmet-async'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      // eslint-disable-next-line
      flexContent: GatsbyTypes.WpPage_Flexcontent
    }
  }
  location?: any
  prefix?: string
  pageContext?: any
}

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { flexContent, seo, title },
  },
  location = {},
  prefix = 'page_Flexcontent',
  pageContext,
}) => {
  if (title === 'Home') {
    useEffect(() => {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Unit 14 ',
        alternateName: 'Unit 14 Beveiliging',
        url: 'https://www.unit14.nl',
        logo: 'https://www.unit14.nl/img/logo-unit14.png',
        sameAs: [
          'https://www.facebook.com/Unit14Beveiliging/',
          'https://www.instagram.com/unit14beveiliging/',
        ],
        description:
          'Unit 14 Beveiliging is een stabiele, betrouwbare beveiligingsorganisatie opgericht in 2001 voor de regio Bunschoten-Spakenburg (Midden Nederland)',
        email: 'info@unit14.nl',
        telephone: '+31334325964',
        address: [
          {
            '@type': 'PostalAddress',
            streetAddress: 'Neerduist 5F',
            addressLocality: 'Bunschoten-Spakenburg',
            postalCode: '3751 LX',
            addressCountry: 'NL',
          },
          {
            streetAddress: 'Marathon 11-F',
            addressLocality: 'Hilversum',
            postalCode: '1213 PG',
            addressCountry: 'NL',
          },
        ],
      })
      document.head.appendChild(script)
      return () => {
        document.head.removeChild(script)
      }
    }, [])
  }

  if (flexContent.homeTemplate) {
    return (
      // <HelmetProvider context={{}}>
      <Layout>
        <SEO seo={seo} />
        <FlexContentHandler
          prefix={prefix}
          fields={flexContent}
          location={location}
        />
      </Layout>
      // </HelmetProvider>
    )
  }

  return (
    // <HelmetProvider context={{}}>
    <Layout>
      <SEO seo={seo} />
      <LayoutPage
        title={title || ''}
        prefix={prefix}
        flexContent={flexContent}
        location={location}
        pageContext={pageContext}
      />
      <ExtraFooterShell fields={flexContent.extrafooter} location={location} />
    </Layout>
    // </HelmetProvider>
  )
}

export const pageQuery = graphql`
  query pageById($pageId: String!) {
    page: wpPage(id: { eq: $pageId }) {
      ...generalPageFragment
    }
  }
`

export default PageTemplate
